module.exports = __webpack_public_path__ + "static/media/mmf_logo.1c8f863a.png";


//////////////////
// WEBPACK FOOTER
// ./src/graphic_assets/mmf_logo.png
// module id = 89
// module chunks = 0